// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    baseUrlProtocol: 'https://',

    nitro_api_domain: "nitro-api.bmsstack.co.uk",
    bms_api_domain: "bmsapi.bmsstack.co.uk",

    cart_life_in_minutes: 15,

    sm_domain: "shop.servicemasterclean.co.uk",
    mm_domain: "shop.merrymaids.co.uk",
    tg_domain: "tg-shop-staging.bmsstack.co.uk",

    sm_main_website_url: "servicemasterclean.co.uk",
    mm_main_website_url: "merrymaids.co.uk",
    tg_main_website_url: "trugreen.co.uk",

    appName: 'Shop',
    pusherDebug: false,
    debug: false,
    localStorageVersion: '2',
    maintenance: false,

};

